import {
  createAsyncActionTypes,
  createActionTypes,
} from '../../util/createLifeomicActionTypes';

const actions = createActionTypes(['ADD_DOWNLOAD_URL_FOR_USAGE_REPORT']);

const asyncActions = createAsyncActionTypes([
  'FETCH_USAGES',
  'FETCH_USAGES_START',
  'FETCH_USAGES_SUCCESS',
  'FETCH_USAGES_ERROR',
  'FETCH_USAGE_REPORT_JSON',
  'FETCH_USAGE_REPORT_JSON_START',
  'FETCH_USAGE_REPORT_JSON_SUCCESS',
  'FETCH_USAGE_REPORT_JSON_ERROR',
  'FETCH_USAGE_REPORTS_JSON',
  'FETCH_USAGE_REPORTS_JSON_START',
  'FETCH_USAGE_REPORTS_JSON_SUCCESS',
  'FETCH_USAGE_REPORTS_JSON_ERROR',
  'FETCH_USAGE_REPORT_DOWNLOAD_URL',
  'FETCH_USAGE_REPORT_DOWNLOAD_URL_START',
  'FETCH_USAGE_REPORT_DOWNLOAD_URL_SUCCESS',
  'FETCH_USAGE_REPORT_DOWNLOAD_URL_ERROR',
]);

export default {
  ...actions,
  ...asyncActions,
};
